var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131.619,
    height: 133.858,
    viewBox: "0 0 131.619 133.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "co2",
    transform: "translate(-4.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2297",
    "data-name": "Group 2297",
    transform: "translate(4.28 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5113",
    "data-name": "Path 5113",
    d: "M131.312,20.049a2.614,2.614,0,1,0-4.6,2.489A32.959,32.959,0,1,1,111.372,8.195a2.614,2.614,0,0,0,2.172-4.756A38.23,38.23,0,0,0,59.468,38.216c0,.079,0,.158,0,.237A32.33,32.33,0,0,0,36.989,40.34,18.258,18.258,0,0,0,9.441,62.7a23.992,23.992,0,0,0-5.16,15.046,24.265,24.265,0,0,0,24.341,23.924h5.246v14.4a13.135,13.135,0,0,1-3.083,8.448l-3.424,4.066H18.625a2.614,2.614,0,0,0-2.614,2.614,2.65,2.65,0,0,0,2.614,2.656H98.355a2.651,2.651,0,0,0,2.614-2.656,2.615,2.615,0,0,0-2.614-2.614H61.37l-3.424-4.066a13.135,13.135,0,0,1-3.083-8.448V101.408A32.213,32.213,0,0,0,82.72,73.378a38.222,38.222,0,0,0,48.593-53.329ZM34.2,128.587l.588-.7A18.37,18.37,0,0,0,39.1,116.073V99.065s0,0,0-.008V96.132a2.615,2.615,0,0,0-.738-1.821L27.962,83.6a2.709,2.709,0,0,1,3.851-3.8l2.82,2.82h0a2.614,2.614,0,0,0,3.6.092l10.094-9.119,5.6-5.059a2.562,2.562,0,0,1,3.487,3.754L50.443,78.95a2.614,2.614,0,0,0-.808,1.89v35.232a18.37,18.37,0,0,0,4.312,11.816l.588.7H34.2ZM54.864,96.132V81.961l6.166-5.891A7.792,7.792,0,0,0,50.424,64.654L47.051,67.7,36.573,77.166,35.51,76.1a7.861,7.861,0,0,0-10.636-.355,7.946,7.946,0,0,0-.665,11.49l8.931,9.205H28.622A19.023,19.023,0,0,1,9.51,77.716a18.784,18.784,0,0,1,5-12.906,2.615,2.615,0,0,0,.309-3.141A13.026,13.026,0,0,1,34.839,45.362a2.614,2.614,0,0,0,3.037.39,27.065,27.065,0,0,1,22.042-1.669A38.557,38.557,0,0,0,77.7,70.793,26.91,26.91,0,0,1,54.864,96.132Z",
    transform: "translate(-4.28 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5114",
    "data-name": "Path 5114",
    d: "M125.522,53.039l6.28,5.292a2.641,2.641,0,0,0,3.283.07l6.854-5.292a2.614,2.614,0,0,0-3.2-4.139L136.1,51.008a8.129,8.129,0,0,1,8.119-8.042h2.5a2.614,2.614,0,1,0,0-5.229h-2.5a13.363,13.363,0,0,0-13.34,12.98l-1.99-1.677a2.614,2.614,0,0,0-3.369,4Z",
    transform: "translate(-93.137 -27.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5115",
    "data-name": "Path 5115",
    d: "M322.926,312.992a2.615,2.615,0,0,0-2.614,2.614v2.5a8.129,8.129,0,0,1-8.042,8.119l2.038-2.639a2.614,2.614,0,1,0-4.139-3.2l-5.292,6.854a2.64,2.64,0,0,0,.07,3.283l5.292,6.28a2.614,2.614,0,1,0,4-3.369l-1.677-1.99a13.363,13.363,0,0,0,12.979-13.34v-2.5a2.614,2.614,0,0,0-2.614-2.615Z",
    transform: "translate(-225.892 -231.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5116",
    "data-name": "Path 5116",
    d: "M270.93,108.621a4.105,4.105,0,0,1,2.308.7,2.614,2.614,0,1,0,2.927-4.332,9.361,9.361,0,1,0-5.235,17.121,8.105,8.105,0,0,0,6.253-2.838,2.614,2.614,0,0,0-4.006-3.361,2.854,2.854,0,0,1-2.247.97,4.132,4.132,0,1,1,0-8.264Z",
    transform: "translate(-194.303 -76.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5117",
    "data-name": "Path 5117",
    d: "M404.638,143.749a2.614,2.614,0,1,0,5.131,1.007c.2-1.007,1.8-.8,1.69.212a6.606,6.606,0,0,1-1.014,1.939c-2.142,3.061-3.419,4.733-4.105,5.631-.881,1.153-1.576,2.064-1.15,3.446a2.7,2.7,0,0,0,1.729,1.758c.342.114,5.846.18,7.792.155a2.614,2.614,0,0,0-.032-5.229h-.034c-.623.008-1.266.014-1.9.02.562-.775,1.219-1.694,1.981-2.784,1.463-2.091,2.536-4.553,1.609-7.082a6.094,6.094,0,0,0-11.7.925Z",
    transform: "translate(-299.932 -102.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5118",
    "data-name": "Path 5118",
    d: "M328.306,112.753a9.361,9.361,0,1,0,9.361-9.361A9.371,9.371,0,0,0,328.306,112.753Zm13.492,0a4.132,4.132,0,1,1-4.132-4.132A4.137,4.137,0,0,1,341.8,112.753Z",
    transform: "translate(-243.592 -76.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5119",
    "data-name": "Path 5119",
    d: "M445.86,41.366a2.612,2.612,0,1,0,1.411-3.414A2.634,2.634,0,0,0,445.86,41.366Z",
    transform: "translate(-330.269 -27.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5120",
    "data-name": "Path 5120",
    d: "M8.349,492.469a2.612,2.612,0,1,0,.984,3.119A2.631,2.631,0,0,0,8.349,492.469Z",
    transform: "translate(-4.283 -363.398)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/co2.6dab171f98f6f5e78cbf7406f7a38f6f.svg";
export { ForwardRef as ReactComponent };